import { mayEnable, usePush } from '@agos/customer-core'
import { T, tt } from '@agos/shared'
import { useState } from 'react'

/**
 * The offer to turn on push notifications — FB-C03.
 *
 * **The key is checked before the browser's own answers.** `GET /push/public-key` answers an empty
 * string on this data while `customer_push_subscriptions` holds **114** rows across 104 customers, so
 * 114 browsers are subscribed to a channel that cannot send. Legacy reports `granted-active` for every
 * one of them, because its state machine never asks whether a key exists. Here `unconfigured` is a
 * state of its own and the banner does not offer to enable something that cannot deliver.
 *
 * So on this stack the banner never appears, and that is the correct behaviour rather than a gap.
 *
 * **The state and the subscribe are `usePush`'s since §9.239**, shared with the profile's switch. This
 * component had its own copy of both, and the copy that had never been rendered was the profile's
 * literal `false` — FB-397.
 */
export function PushOptInBanner() {
  const push = usePush()
  // *Teraz nie* — this page view only, as before.
  const [dismissed, setDismissed] = useState(false)

  if (dismissed || !mayEnable(push.state)) return null

  return (
    <div
      className="rounded-2xl border border-border bg-card p-3 space-y-2"
      data-push-banner={push.state}
    >
      <p className="text-xs">
        <T>Chcete vedieť, keď bude objednávka na ceste? Zapneme upozornenia.</T>
      </p>
      {push.problem !== '' && (
        <p className="text-[11px] text-red-500" data-push-problem>
          {push.problem}
        </p>
      )}
      <div className="flex gap-2">
        <button
          type="button"
          data-push-enable
          disabled={push.busy}
          onClick={() => void push.enable()}
          className="min-h-[36px] flex-1 rounded-xl bg-primary text-primary-foreground text-xs font-bold"
        >
          <T>Zapnúť</T>
        </button>
        <button
          type="button"
          data-push-dismiss
          onClick={() => setDismissed(true)}
          className="min-h-[36px] flex-1 rounded-xl border border-border text-xs font-semibold"
        >
          {tt('Teraz nie')}
        </button>
      </div>
    </div>
  )
}
